import {Link} from '@tanstack/react-router'
import {useTranslations} from 'use-intl'
import useBasketOverlayState from '~/hooks/useBasketOverlayState'
import {Button} from '~/components/common/Button'
import Card from '~/components/common/Card'

export const EmptyBasket = () => {
    const t = useTranslations('basket.empty')
    const {hideBasketOverlay} = useBasketOverlayState()

    return (
        <div className="px-5 py-8 space-y-6">
            <img
                src="/empty_cart.png"
                alt={t('imageAlt')}
                className="max-w-64 sm:max-w-sm w-full h-auto mx-auto aspect-square object-center object-contain"
            />
            <div className="text-center space-y-2">
                <h2 className="text-2xl font-bold">{t('title')}</h2>
                <p>{t('description')}</p>
            </div>
            <Button
                className="md:max-w-md md:mx-auto"
                as={Link}
                variant="secondary"
                to="/products"
                preload="viewport"
                onClick={hideBasketOverlay}
            >
                {t('action')}
            </Button>
        </div>
    )
}

export const EmptyBasketCard = () => (
    <Card>
        <EmptyBasket />
    </Card>
)
